import classNames from "classnames";
import React, { FC } from "react";

import { styles } from "./text.scss";


export const Text: FC<{
    content?: string;
    ellipsize?: boolean;
    fit?: boolean;
    children?: React.ReactNode;
}> =
    ({ content, ellipsize, fit, children }) =>
    {
        children = children ?? content;
        const title = ellipsize && (typeof children == "string") && children;
        return (
            <div title={title} className={classNames(styles.text, ellipsize && styles.ellipsize, fit && styles.fit)}>
                {children}
            </div>
        );
    };
